interface Config {
    API_BASE?: string
    BaseName?: string
    Env?: string
}

let config: Config = {
    API_BASE: process.env.REACT_APP_API_BASE,
    BaseName: '/',
    Env: 'dev' 
}

export default config